import { Form, Select } from 'antd';
import type { DirectoryTagView } from '../features/directory-tags/directory-tags.api';
import { tagChoices } from '../policies/tag-labels';

interface DirectoryTagsFieldProps {
  name: string;
  label: string;
  extra: string;
  catalogue: DirectoryTagView[];
  /** Codes the record being edited already carries, so a since-deactivated entry still shows. */
  carried: string[];
}

/** Picks from the catalogue and opens with its choices; a name typed that the catalogue lacks is added to it when the record is saved. */
export function DirectoryTagsField({ name, label, extra, catalogue, carried }: DirectoryTagsFieldProps) {
  return (
    <Form.Item name={name} label={label} extra={extra} rules={[{ required: true, message: `Give at least one ${label.toLowerCase()}` }]}>
      <Select
        mode="tags"
        placeholder={`Select or add ${label.toLowerCase()}`}
        tokenSeparators={[',']}
        options={tagChoices(catalogue, carried)}
        optionFilterProp="label"
      />
    </Form.Item>
  );
}
